import { PolicyType } from 'src/content/Products/Policies/PolicyType'

export const findPolicy = (
  policies: IDiscountPolicies[],
  quantity: number,
): IDiscountPolicies => {
  return policies.find(({ min, max }) => quantity >= min && quantity <= max)
}

export const findPolicyByPrice = (
  policies: IDiscountPolicies[],
  price: number,
): IDiscountPolicies => {
  if (policies?.length === 0) return null
  return policies.find(({ amount }) => amount === price)
}

export const calculateNewDiscount = (
  policy: IDiscountPolicies,
  total: number,
  quantity: number,
): number => {
  if (policy && policy.type === PolicyType.DISCOUNT) {
    const { amount, percentage } = policy
    let value: number
    if (percentage) {
      value = (amount / 100) * total
    } else value = quantity * amount

    return Number(value.toFixed(2))
  }
  return 0
}
